import { getEnv } from '../env'

const env = getEnv()

export enum EVENTS {
  ANALYSIS_COMPLETED = 'ANALYSIS_COMPLETED',
  RETRY = 'RETRY',
}

export const postMessageToParent = (event: EVENTS) => {
  window.parent.postMessage(event, env.REACT_APP_EXTENSION_URL)
  window.parent.postMessage(event, env.REACT_APP_VAULT_URL)
}
